import React from 'react';
import { Select } from 'antd';
import states from 'constants/states';

const SelectStates = ({ ...rest }) => {
  return (
    <Select {...rest}>
      {states.map(({ initials, name }) => (
        <Select.Option key={initials} value={initials}>
          {name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectStates;
